import { StackChild, StackContainer } from 'inquiry/components/StackBase';
import UiComponentView from 'inquiry/components/UiComponentView';
import { useApply } from 'inquiry/lib/jsonLogic';
import { HorizontalStackComponent, ParentComponentProps } from 'lib/interfaces/ui-components';
import { UiComponentActionsApi } from 'verify/lib/interfaces/uiComponent';
import { Inquiry } from 'verify/models/inquiry';

interface HorizontalStackProps extends ParentComponentProps {
  component: HorizontalStackComponent;
  inquiry: Inquiry;
  actionsApi: UiComponentActionsApi;
  inquiryLoading: boolean;
}

const HorizontalStack = ({ component, ...props }: HorizontalStackProps) => {
  const { hidden } = component.attributes;
  const { inquiry } = props;

  const apply = useApply(component.name, inquiry.attributes['next-step'].name);
  const isHidden = apply<boolean>(hidden);

  // WARNING: This will currently misbehave if form components are placed in a
  // hidden stack. This is because the server will still attempt to validate
  // those components.
  if (isHidden) {
    return null;
  }

  return (
    <StackContainer styles={component.styles}>
      {!props.isPreview &&
        component.attributes.children.map((childComponent, index) => (
          <StackChild key={childComponent.name} styles={component.styles} index={index}>
            <UiComponentView {...props} component={childComponent} />
          </StackChild>
        ))}
      {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
      {props.isPreview && props.childPreviews.map((childPreview) => childPreview.component)}
    </StackContainer>
  );
};

export default HorizontalStack;
